export const countriesList = [
	{ "name": "France", "code": "FR", "highlighted": true },
	{ "name": "Belgique", "code": "BE", "highlighted": true },
	{ "name": "Andorre", "code": "AD" },
	{ "name": "Émirats Arabes Unis", "code": "AE" },
	{ "name": "Afghanistan", "code": "AF" },
	{ "name": "Antigua-Et-Barbuda", "code": "AG" },
	{ "name": "Anguilla", "code": "AI" },
	{ "name": "Albanie", "code": "AL" },
	{ "name": "Arménie", "code": "AM" },
	{ "name": "Angola", "code": "AO" },
	{ "name": "Région Asie/Pacifique", "code": "AP" },
	{ "name": "Antarctique", "code": "AQ" },
	{ "name": "Argentine", "code": "AR" },
	{ "name": "Samoa Américaines", "code": "AS" },
	{ "name": "Autriche", "code": "AT" },
	{ "name": "Australie", "code": "AU" },
	{ "name": "Aruba", "code": "AW" },
	{ "name": "Îles Åland", "code": "AX" },
	{ "name": "Azerbaïdjan", "code": "AZ" },
	{ "name": "Bosnie-Herzégovine", "code": "BA" },
	{ "name": "Barbad", "code": "BB" },
	{ "name": "Bangladesh", "code": "BD" },
	{ "name": "Burkina Faso", "code": "BF" },
	{ "name": "Bulgarie", "code": "BG" },
	{ "name": "Bahreïn", "code": "BH" },
	{ "name": "Burundi", "code": "BI" },
	{ "name": "Bénin", "code": "BJ" },
	{ "name": "Saint-Barthélemy", "code": "BL" },
	{ "name": "Bermudes", "code": "BM" },
	{ "name": "Brunei Darussalam", "code": "BN" },
	{ "name": "État Plurinational De Bolivie", "code": "BO" },
	{ "name": "Bonaire, Saint-Eustache Et Saba", "code": "BQ" },
	{ "name": "Brésil", "code": "BR" },
	{ "name": "Bahamas", "code": "BS" },
	{ "name": "Bhoutan", "code": "BT" },
	{ "name": "Île Bouvet", "code": "BV" },
	{ "name": "Botswana", "code": "BW" },
	{ "name": "Biélorussie", "code": "BY" },
	{ "name": "Belize", "code": "BZ" },
	{ "name": "Canada", "code": "CA" },
	{ "name": "Îles Cocos", "code": "CC" },
	{ "name": "République Démocratique Du Congo", "code": "CD" },
	{ "name": "République Centrafricaine", "code": "CF" },
	{ "name": "Congo", "code": "CG" },
	{ "name": "Suisse", "code": "CH" },
	{ "name": "Côte D'Ivoire", "code": "CI" },
	{ "name": "Îles Cook", "code": "CK" },
	{ "name": "Chili", "code": "CL" },
	{ "name": "Cameroun", "code": "CM" },
	{ "name": "Chine", "code": "CN" },
	{ "name": "Colombie", "code": "CO" },
	{ "name": "Costa Rica", "code": "CR" },
	{ "name": "Cuba", "code": "CU" },
	{ "name": "Cap-Vert", "code": "CV" },
	{ "name": "Curaçao", "code": "CW" },
	{ "name": "Île Christmas", "code": "CX" },
	{ "name": "Chypre", "code": "CY" },
	{ "name": "République Tchèque", "code": "CZ" },
	{ "name": "Allemagne", "code": "DE" },
	{ "name": "Djibouti", "code": "DJ" },
	{ "name": "Denmark", "code": "DK" },
	{ "name": "Dominique", "code": "DM" },
	{ "name": "République Dominicaine", "code": "DO" },
	{ "name": "Algérie", "code": "DZ" },
	{ "name": "Équateur", "code": "EC" },
	{ "name": "Estonie", "code": "EE" },
	{ "name": "Égypte", "code": "EG" },
	{ "name": "Sahara Occidental", "code": "EH" },
	{ "name": "Érythrée", "code": "ER" },
	{ "name": "Espagne", "code": "ES" },
	{ "name": "Éthiopie", "code": "ET" },
	{ "name": "Europe", "code": "EU" },
	{ "name": "Finlande", "code": "FI" },
	{ "name": "Fidji", "code": "FJ" },
	{ "name": "Îles Malouines", "code": "FK" },
	{ "name": "États Fédérés De Micronésie", "code": "FM" },
	{ "name": "Îles Féroé", "code": "FO" },
	{ "name": "Gabon", "code": "GA" },
	{ "name": "Royaume-Uni", "code": "GB" },
	{ "name": "Grenade", "code": "GD" },
	{ "name": "Géorgie", "code": "GE" },
	{ "name": "Guyane", "code": "GF" },
	{ "name": "Guernesey", "code": "GG" },
	{ "name": "Ghana", "code": "GH" },
	{ "name": "Gibraltar", "code": "GI" },
	{ "name": "Groenland", "code": "GL" },
	{ "name": "Gambie", "code": "GM" },
	{ "name": "Guinée", "code": "GN" },
	{ "name": "Guadeloupe", "code": "GP" },
	{ "name": "Guinée Équatoriale", "code": "GQ" },
	{ "name": "Grèce", "code": "GR" },
	{ "name": "Géorgie Du Sud-Et-Les Îles Sandwich Du Sud", "code": "GS" },
	{ "name": "Guatemala", "code": "GT" },
	{ "name": "Guam", "code": "GU" },
	{ "name": "Guinée-Bissau", "code": "GW" },
	{ "name": "Guyana", "code": "GY" },
	{ "name": "Hong Kong", "code": "HK" },
	{ "name": "Îles Heard-Et-MacDonald", "code": "HM" },
	{ "name": "Honduras", "code": "HN" },
	{ "name": "Croatie", "code": "HR" },
	{ "name": "Haïti", "code": "HT" },
	{ "name": "Hongrie", "code": "HU" },
	{ "name": "Indonésie", "code": "ID" },
	{ "name": "Irlande", "code": "IE" },
	{ "name": "Israël", "code": "IL" },
	{ "name": "Île De Man", "code": "IM" },
	{ "name": "Inde", "code": "IN" },
	{ "name": "Territoire Britannique De L'océan Indien", "code": "IO" },
	{ "name": "Irak", "code": "IQ" },
	{ "name": "République Islamique D'Iran", "code": "IR" },
	{ "name": "Islande", "code": "IS" },
	{ "name": "Italie", "code": "IT" },
	{ "name": "Jersey", "code": "JE" },
	{ "name": "Jamaïque", "code": "JM" },
	{ "name": "Jordanie", "code": "JO" },
	{ "name": "Japon", "code": "JP" },
	{ "name": "Kenya", "code": "KE" },
	{ "name": "Kirghizistan", "code": "KG" },
	{ "name": "Cambodge", "code": "KH" },
	{ "name": "Kiribati", "code": "KI" },
	{ "name": "Comores", "code": "KM" },
	{ "name": "Saint-Christophe-et-Niévès", "code": "KN" },
	{ "name": "République Populaire Démocratique De Corée", "code": "KP" },
	{ "name": "République De Corée", "code": "KR" },
	{ "name": "Koweït", "code": "KW" },
	{ "name": "Îles Caïmans", "code": "KY" },
	{ "name": "Kazakhstan", "code": "KZ" },
	{ "name": "République Démocratique Populaire Lao", "code": "LA" },
	{ "name": "Liban", "code": "LB" },
	{ "name": "Sainte-Lucie", "code": "LC" },
	{ "name": "Liechtenstein", "code": "LI" },
	{ "name": "Sri Lanka", "code": "LK" },
	{ "name": "Liberia", "code": "LR" },
	{ "name": "Lesotho", "code": "LS" },
	{ "name": "Lituanie", "code": "LT" },
	{ "name": "Luxembourg", "code": "LU" },
	{ "name": "Lettonie", "code": "LV" },
	{ "name": "Libye", "code": "LY" },
	{ "name": "Maroc", "code": "MA" },
	{ "name": "Monaco", "code": "MC" },
	{ "name": "République De Moldavie", "code": "MD" },
	{ "name": "Monténégro", "code": "ME" },
	{ "name": "Saint-Martin (Partie Française)", "code": "MF" },
	{ "name": "Madagascar", "code": "MG" },
	{ "name": "Îles Marshall", "code": "MH" },
	{ "name": "Macédoine", "code": "MK" },
	{ "name": "Mali", "code": "ML" },
	{ "name": "Birmanie", "code": "MM" },
	{ "name": "Mongolie", "code": "MN" },
	{ "name": "Macao", "code": "MO" },
	{ "name": "Îles Mariannes Du Nord", "code": "MP" },
	{ "name": "Martinique", "code": "MQ" },
	{ "name": "Mauritanie", "code": "MR" },
	{ "name": "Montserrat", "code": "MS" },
	{ "name": "Malte", "code": "MT" },
	{ "name": "Maurice", "code": "MU" },
	{ "name": "Maldives", "code": "MV" },
	{ "name": "Malawi", "code": "MW" },
	{ "name": "Mexique", "code": "MX" },
	{ "name": "Malaisie", "code": "MY" },
	{ "name": "Mozambique", "code": "MZ" },
	{ "name": "Namibie", "code": "NA" },
	{ "name": "Nouvelle-Calédonie", "code": "NC" },
	{ "name": "Niger", "code": "NE" },
	{ "name": "Île Norfolk", "code": "NF" },
	{ "name": "Nigéria", "code": "NG" },
	{ "name": "Nicaragua", "code": "NI" },
	{ "name": "Pays-Bas", "code": "NL" },
	{ "name": "Norvège", "code": "NO" },
	{ "name": "Népal", "code": "NP" },
	{ "name": "Nauru", "code": "NR" },
	{ "name": "Niue", "code": "NU" },
	{ "name": "Nouvelle-Zélande", "code": "NZ" },
	{ "name": "Oman", "code": "OM" },
	{ "name": "Panama", "code": "PA" },
	{ "name": "Pérou", "code": "PE" },
	{ "name": "Polynésie Française", "code": "PF" },
	{ "name": "Papouasie-Nouvelle-Guinée", "code": "PG" },
	{ "name": "Philippines", "code": "PH" },
	{ "name": "Pakistan", "code": "PK" },
	{ "name": "Pologne", "code": "PL" },
	{ "name": "Saint-Pierre-Et-Miquelon", "code": "PM" },
	{ "name": "Pitcairn", "code": "PN" },
	{ "name": "Porto Rico", "code": "PR" },
	{ "name": "Territoires Palestiniens Occupés", "code": "PS" },
	{ "name": "Portugal", "code": "PT" },
	{ "name": "Palaos", "code": "PW" },
	{ "name": "Paraguay", "code": "PY" },
	{ "name": "Qatar", "code": "QA" },
	{ "name": "Réunion", "code": "RE" },
	{ "name": "Roumanie", "code": "RO" },
	{ "name": "Serbie", "code": "RS" },
	{ "name": "Fédération De Russie", "code": "RU" },
	{ "name": "Rwanda", "code": "RW" },
	{ "name": "Arabie Saoudite", "code": "SA" },
	{ "name": "Îles Salomon", "code": "SB" },
	{ "name": "Seychelles", "code": "SC" },
	{ "name": "Soudan", "code": "SD" },
	{ "name": "Suède", "code": "SE" },
	{ "name": "Singapour", "code": "SG" },
	{ "name": "Sainte-Hélène", "code": "SH" },
	{ "name": "Slovénie", "code": "SI" },
	{ "name": "Svalbard Et Jan Mayen", "code": "SJ" },
	{ "name": "Slovaquie", "code": "SK" },
	{ "name": "Sierra Leone", "code": "SL" },
	{ "name": "Saint-Marin", "code": "SM" },
	{ "name": "Sénégal", "code": "SN" },
	{ "name": "Somalie", "code": "SO" },
	{ "name": "Suriname", "code": "SR" },
	{ "name": "Soudan Du Sud", "code": "SS" },
	{ "name": "Sao Tomé-Et-Principe", "code": "ST" },
	{ "name": "République Du Salvador", "code": "SV" },
	{ "name": "Saint-Martin (Partie Néerlandaise)", "code": "SX" },
	{ "name": "République Arabe Syrienne", "code": "SY" },
	{ "name": "Swaziland", "code": "SZ" },
	{ "name": "Îles Turks-Et-Caïcos", "code": "TC" },
	{ "name": "Tchad", "code": "TD" },
	{ "name": "Terres Australes Françaises", "code": "TF" },
	{ "name": "Togo", "code": "TG" },
	{ "name": "Thaïlande", "code": "TH" },
	{ "name": "Tadjikistan", "code": "TJ" },
	{ "name": "Tokelau", "code": "TK" },
	{ "name": "Timor-Leste", "code": "TL" },
	{ "name": "Turkménistan", "code": "TM" },
	{ "name": "Tunisie", "code": "TN" },
	{ "name": "Tonga", "code": "TO" },
	{ "name": "Turquie", "code": "TR" },
	{ "name": "Trinité-Et-Tobago", "code": "TT" },
	{ "name": "Tuvalu", "code": "TV" },
	{ "name": "Taïwan", "code": "TW" },
	{ "name": "République-Unie De Tanzanie", "code": "TZ" },
	{ "name": "Ukraine", "code": "UA" },
	{ "name": "Ouganda", "code": "UG" },
	{ "name": "Îles Mineures Éloignées Des États-Unis", "code": "UM" },
	{ "name": "États-Unis", "code": "US" },
	{ "name": "Uruguay", "code": "UY" },
	{ "name": "Ouzbékistan", "code": "UZ" },
	{ "name": "Saint-Siège (État De La Cité Du Vatican)", "code": "VA" },
	{ "name": "Saint-Vincent-Et-Les Grenadines", "code": "VC" },
	{ "name": "Venezuela", "code": "VE" },
	{ "name": "Îles Vierges Britanniques", "code": "VG" },
	{ "name": "Îles Vierges Des États-Unis", "code": "VI" },
	{ "name": "Viet Nam", "code": "VN" },
	{ "name": "Vanuatu", "code": "VU" },
	{ "name": "Wallis Et Futuna", "code": "WF" },
	{ "name": "Samoa", "code": "WS" },
	{ "name": "Yémen", "code": "YE" },
	{ "name": "Mayotte", "code": "YT" },
	{ "name": "Afrique Du Sud", "code": "ZA" },
	{ "name": "Zambie", "code": "ZM" },
	{ "name": "Zimbabwe", "code": "ZW" }
]